const labels = {
  chain: "Rede",
  pos: "Código",
  areasCode: "Código de área",
  uf: "Estado",
  city: "Cidade",
  status: "Situação"
}

export default {
  getUuid: state => state.uuid,
  getIsEditing: state => state.isEditing,
  getActive: state => state.active,
  getPos: state => state.pos,
  getCurrentStep: state => state.currentStep,
  getSteps: state => state.steps,
  getStepNameRoutes: state => state.stepNameRoutes,
  getAllRolesList: state => state.allRolesList,

  getSavePosPayload: state => {
    const payload = {
      chain_uuid: state.pos.chain,
      cnpj: state.pos.cnpj,
      name: state.pos.name,
      code: state.pos.code,
      active: state.pos.active || false,
      departments: state.pos.departments,
      address: {
        postcode: state.pos.postcode,
        address: state.pos.address,
        number: state.pos.number,
        neighborhood: state.pos.neighborhood,
        city_uuid: state.pos.city
      },
      roles: state.pos.roles,
      user: state.pos.user
    }
    if (state.pos.address_uuid) payload.address.uuid = state.pos.address_uuid
    if (state.pos.noNumber) delete payload.address.number
    return payload
  },

  queryChain: state => state.filter.chain.join("&"),

  queryAreasCode: state => {
    return state.filter.areasCode
      ? `search=area_code:${state.filter.areasCode.replace("area_codes=", "")}`
      : ""
  },
  queryPos: state => {
    return state.filter.pos ? `search=code:${state.filter.pos}` : ""
  },

  queryUF: state => {
    return state.filter.uf ? `search=address.state.id:${state.filter.uf}` : ""
  },

  queryCity: state => {
    return state.filter.city
      ? `search=address.city.uuid:${state.filter.city}`
      : ""
  },

  status: state => {
    const status = state.optionsStatus.filter(status =>
      state.filter.status.includes(status.value)
    )

    return status ? status.map(status => status.text).join(", ") : ""
  },

  pos: state => {
    return state.filter.pos
  },

  areasCode: state => {
    return state.filter.areasCode.replace("area_codes=", "")
  },

  city: state => {
    return state.filter.city
  },

  uf: state => {
    const uf = state.optionsStates.filter(uf =>
      state.filter.uf.includes(uf.value)
    )

    return uf ? uf.map(uf => uf.text).join(", ") : ""
  },

  chain: (state, getters, rootState, rootGetters) => {
    const retailChain = rootGetters[
      "RetailChainsAndPosReactive/optionsRetailChains"
    ].filter(retailChain =>
      state.filter.retailChain.includes(retailChain.value)
    )

    return retailChain
      ? retailChain.map(retailChain => retailChain.text).join(", ")
      : ""
  },

  finalQuery: (
    state,
    { queryAreasCode, queryUF, queryCity, queryPos, queryStatus, queryChain }
  ) => {
    const array = [
      state.filter.status,
      queryAreasCode,
      queryUF,
      queryCity,
      queryPos,
      queryStatus,
      queryChain
    ]

    return array
      .reduce((acc, item) => {
        if (item) return `${acc}&${item}`

        return acc
      }, "")
      .slice(1)
  },
  fieldAdvancedFilter: (
    state,
    { retailChain, pos, status, areasCode, uf, city }
  ) => {
    const fields = {
      retailChain,
      pos,
      status,
      areasCode,
      uf,
      city
    }

    return Object.keys(fields).reduce((acc, key) => {
      if (fields[key])
        return [
          ...acc,
          {
            label: labels[key],
            value: fields[key],
            key
          }
        ]
      return acc
    }, [])
  }
}
